export default __webpack_public_path__ + "static/291-6cb4cc2ba1b70a392854671645654a35.gif";